export const SelectModes = {
  WHITELIST: 'whitelist',
  BLACKLIST: 'blacklist',
};
